import * as React from 'react';
import { Link } from 'react-router-dom';
import './auth-welcome-block.scss';

interface AuthWelcomeBlockProps {
  header: string;
  signup?: boolean;
  link?: string;
}

/**
 * Renders the authentication welcome block.
 *
 * @param {Object} props - The props for the AuthWelcomeBlock component.
 * @param {string} props.header - The header text to be displayed.
 * @param {boolean} props.signup - Indicates if it is a sign-up page.
 * @param {string} props.link - The link URL for the "Log in" text.
 * @returns {React.Element} The rendered welcome block.
 */
const AuthWelcomeBlock = ({
  header,
  signup,
  link,
}: AuthWelcomeBlockProps): React.ReactElement => (
  <div className="AuthWelcomeBlock__Welcome">
    <h4>{header}</h4>
    {signup && (
      <p className="grey-text text-darken-1">
        Already have an account? <Link to={link as string}>Log in</Link>
      </p>
    )}
  </div>
);

export default AuthWelcomeBlock;
